(function(){
  function money(cents, currency){
    try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:currency||'EUR'}).format(cents/100)}catch(e){return (cents/100).toFixed(2)}
  }
  document.addEventListener('click',function(e){
    const thumb=e.target.closest('[data-xo-thumb]');
    if(thumb){
      const gallery=thumb.closest('[data-xo-gallery]');
      if(!gallery)return;
      const id=thumb.dataset.mediaId;
      gallery.querySelectorAll('[data-xo-media]').forEach(el=>el.hidden=el.dataset.mediaId!==id);
      gallery.querySelectorAll('[data-xo-thumb]').forEach(el=>el.classList.toggle('is-active',el===thumb));
    }
  });
  document.addEventListener('change',function(e){
    const product=e.target.closest('[data-xo-product]');
    if(!product)return;
    if(e.target.matches('[data-xo-variant]')){
      const input=product.querySelector('input[name="id"]');
      if(input)input.value=e.target.value;
      const price=parseInt(e.target.dataset.price||'0',10);
      product.dataset.variantPrice=price;
      const priceEl=product.querySelector('[data-xo-current-price]');
      if(priceEl)priceEl.textContent=e.target.dataset.priceText||priceEl.textContent;
      const available=e.target.dataset.available==='true';
      const submit=product.querySelector('[data-xo-submit]');
      if(submit){submit.disabled=!available;submit.setAttribute('aria-disabled',available?'false':'true')}
      const stock=product.querySelector('[data-xo-stock]');
      if(stock)stock.textContent=available?product.dataset.inStockLabel:product.dataset.outStockLabel;
      product.querySelectorAll('[data-xo-pack]').forEach(pack=>{
        const override=pack.dataset.priceOverride;
        if(!override){
          const qty=parseInt(pack.dataset.quantity||'1',10);
          const out=pack.querySelector('[data-xo-pack-price]');
          if(out&&price)out.textContent=money(price*qty,product.dataset.currency);
        }
      });
      const selectedPack=product.querySelector('[data-xo-pack-radio]:checked');
      if(selectedPack){
        const pack=selectedPack.closest('[data-xo-pack]');
        const out=pack&&pack.querySelector('[data-xo-pack-price]');
        const submitPrice=product.querySelector('[data-xo-submit-price]');
        if(out&&submitPrice)submitPrice.textContent=out.textContent;
      }
    }
    if(e.target.matches('[data-xo-pack-radio]')){
      const pack=e.target.closest('[data-xo-pack]');
      const qty=pack?parseInt(pack.dataset.quantity||'1',10):1;
      const qtyInput=product.querySelector('input[name="quantity"]');
      if(qtyInput)qtyInput.value=qty;
      const selectedPrice=pack?pack.querySelector('[data-xo-pack-price]'):null;
      const submitPrice=product.querySelector('[data-xo-submit-price]');
      if(submitPrice&&selectedPrice)submitPrice.textContent=selectedPrice.textContent;
    }
  });
  document.addEventListener('DOMContentLoaded',function(){
    document.querySelectorAll('[data-xo-product]').forEach(product=>{
      const variant=product.querySelector('[data-xo-variant]:checked');
      if(variant)variant.dispatchEvent(new Event('change',{bubbles:true}));
      const pack=product.querySelector('[data-xo-pack-radio]:checked');
      if(pack)pack.dispatchEvent(new Event('change',{bubbles:true}));
    });
  });
})();
